import { KmsTypeComponent } from "@kaltura/mediaspace-shared-types";
import { ErrorBoundary } from "@kaltura/mediaspace-shared-ui";
import { getComponentFromPath } from "@kaltura/mediaspace-shared-utils";

interface PreSaveComponentProps {
    kmsComponent: KmsTypeComponent;
    display: boolean;
    formData: { entryIds: string[]; data: any };
    saveConfirmationResolvePromise: ((value: { confirm: boolean; isEditable: boolean }) => void) | null;
    setDisplayPreSaveComponent: (display: boolean) => void;
}

/**
 * Pre-save component that displays a confirmation component before saving the file uploaded data.
 * User should confirm or cancel the save action.
 */
export const PreSaveComponent = ({
    kmsComponent,
    display,
    formData,
    saveConfirmationResolvePromise,
    setDisplayPreSaveComponent,
}: PreSaveComponentProps) => {
    const Component = getComponentFromPath(kmsComponent.component);

    const handleConfirm = (isEditable: boolean) => {
        if (saveConfirmationResolvePromise) {
            saveConfirmationResolvePromise({
                confirm: true,
                isEditable: isEditable,
            });
        }
        setDisplayPreSaveComponent(false);
    };

    const handleCancel = () => {
        if (saveConfirmationResolvePromise) {
            saveConfirmationResolvePromise({ confirm: false, isEditable: true });
        }
        setDisplayPreSaveComponent(false);
    };

    return (
        <ErrorBoundary key={kmsComponent.name} fallback={<></>}>
            <Component
                {...{
                    ...kmsComponent.props,
                    display: display,
                    formData: formData,
                    onConfirm: handleConfirm,
                    onCancel: handleCancel,
                }}
            />
        </ErrorBoundary>
    );
};
